// Datas/horas vindas da API.
// Os datetimes são gravados em UTC, mas podem chegar SEM marcador de fuso
// (naive, ex.: "2026-06-02T19:16:41"). O new Date() do navegador trata string
// sem fuso como horário LOCAL — o que deixava tudo adiantado/atrasado.
// Aqui tratamos "naive = UTC" e formatamos sempre em America/Sao_Paulo.
const TZ = "America/Sao_Paulo";

export function parseApiDateTime(v) {
  if (!v) return null;
  let s = String(v);
  const hasTz = /[Zz]$|[+\-]\d{2}:?\d{2}$/.test(s);
  if (!hasTz) s = `${s.replace(" ", "T")}Z`; // naive => UTC
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function fmtDateTime(v, opts = {}) {
  const d = parseApiDateTime(v);
  if (!d) return "";
  return d.toLocaleString("pt-BR", {
    timeZone: TZ,
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    ...opts,
  });
}

export function timeAgo(v) {
  const d = parseApiDateTime(v);
  if (!d) return "";
  const diff = Math.max(0, Date.now() - d.getTime());
  const min = Math.floor(diff / 60000);
  if (min < 1) return "agora";
  if (min < 60) return `${min}min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}h`;
  const dd = Math.floor(h / 24);
  if (dd < 7) return `${dd}d`;
  return d.toLocaleDateString("pt-BR", { timeZone: TZ, day: "2-digit", month: "2-digit" });
}

// Datas PURAS (sem hora), ex.: nascimento/admissão. NÃO converte fuso (senão
// "2025-12-15" viraria o dia anterior em GMT-3). Só reformata YYYY-MM-DD -> DD/MM/YYYY.
export function fmtDateOnly(v) {
  if (!v) return "";
  const s = String(v).slice(0, 10);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : s;
}
